import { useEffect, useState } from "react";
import useFetching from "../utils/Fetching";

export function useDocuments() {
  const { getFileNames } = useFetching();
  const [list, setList] = useState({});

  useEffect(() => {
    const getDocuments = async () => {
      const response = await getFileNames();
      const obj = {};
      response.forEach((document) => {
        const name = document.substring(0, document.lastIndexOf("."));
        obj[name] = document;
      });
      setList(obj);
    };

    getDocuments();
  }, [getFileNames]);

  return list;
}
